import { IDoc } from "../interfaces/document";

export const isDocOwner = (doc: IDoc, userId: string): boolean =>
  doc.creator?.id === userId;

export const isDocUnsigned = (doc: IDoc): boolean =>
  !doc.signatures?.length;

export const isDocSigning = (doc: IDoc): boolean =>
  doc.error?.code === 115;

export const isDocDisabled = (doc: IDoc): boolean =>
  doc.cancelled || isDocSigning(doc);

export const getDocReadyHint = (doc: IDoc): string | undefined => {
  if (!doc.type?.title) return "Виберіть тип документу";
  const hasMissingAttrs = doc.attributes?.some((a) => a.mandatory && !a.value);
  if (hasMissingAttrs) return "Заповніть обов'язкові атрибути";
  return undefined;
};

export const isDocReadyToSign = (doc: IDoc): boolean => {
  const hasType = !!doc.type?.title;
  const hasRequiredAttributes =
    doc.attributes?.every((a) => (a.mandatory ? !!a.value : true)) ?? true;
  return hasType && hasRequiredAttributes;
};

export const canArchiveDoc = (doc: IDoc, userId: string): boolean =>
  isDocOwner(doc, userId) &&
  isDocUnsigned(doc) &&
  !doc.counterparties?.length &&
  !isDocSigning(doc);
